import api from '@app/api/configurardorPrincipal/ConfiguracionGeneralApi';
import { InventoryApi } from '@app/api/inventario/InventoryApi';
import React, { useState } from 'react';

const TestApi: React.FC = () => {
    const [responseData, setResponseData] = useState<any>(null);
    const [error, setError] = useState<string | null>(null);

    const testApiEndpoint = async () => {
        try {
            // Cambia `/endpoint` por el endpoint que deseas probar
            const response = InventoryApi.getDeviceList();
            setResponseData((await response).data);
            setError(null); // Resetea el error en caso de éxito
        } catch (err: any) {
            setError(err.message || 'Error al llamar a la API');
            setResponseData(null); // Resetea los datos en caso de error
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <h1>Pruebas de API</h1>
            <button onClick={testApiEndpoint}>Probar Endpoint</button>
            {error && <p style={{ color: 'red' }}>Error: {error}</p>}
            {responseData && (
                <div>
                    <h2>Respuesta:</h2>
                    <pre>{JSON.stringify(responseData, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default TestApi;
